<template>
  <path
    id="dashboard"
    d="M24.005,8.56106121 L24.005,22.1448499 C24.005,23.1721954 23.1721958,24.005 22.1448503,24.005 L1.85514974,24.005 C0.827804185,24.005 -0.005,23.1721954 -0.005,22.1448499 L-0.005,8.56106121 C-0.005,7.93655123 0.308390765,7.35375232 0.829386971,7.00930494 L10.974227,0.303390742 C11.5962613,-0.107795779 12.4036956,-0.107795779 13.0257198,0.303383932 L23.1705701,7.00930494 C23.6915734,7.35369555 24.005,7.93651393 24.005,8.56106121 Z M11.9999785,2.02380195 L1.99583333,8.63671446 L1.99583333,22.0041668 L22.0041667,22.0041668 L22.0041667,8.63674289 L11.9999785,2.02380195 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'DashboardIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
